import { connect } from "react-redux"
import InnerFrameImageComponent from "../../components/Frame/InnerFrameImageComponent"

const mapStateToProps = (state, ownProps) => ({
    browserName: state.localStore.get("browserName")
});

const mapDispatchToProps = (dispatch, ownProps) => ({});

const InnerFrameImage = connect(
    mapStateToProps,
    mapDispatchToProps
)(InnerFrameImageComponent)

export default InnerFrameImage;


// WEBPACK FOOTER //
// ./src/containers/Frame/InnerFrameImage.js